(function() {
  function getDisplayedPrice() {
    // Try multiple selectors - theme uses GemPages pricing
    var selectors = [
      '.gf_product-price.money',
      '.gf_product-price',
      '.sls-one-time-price .sls-price',
      '.price-list .price:not(.price--compare)',
      '.product-form__info-content .price'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        var text = el.textContent.trim().replace(/[^0-9.]/g, '');
        var price = parseFloat(text);
        if (price > 0) return price;
      }
    }
    return null;
  }

  // Write text only when it differs. Setting textContent to the same value still
  // replaces the text node, which the table observer below sees as a mutation and
  // answers with another update: an endless loop that kept the main thread 100% busy.
  function setText(el, next) {
    if (el.textContent !== next) el.textContent = next;
  }

  function updateVolumeTable() {
    var basePrice = getDisplayedPrice();
    if (!basePrice) return;

    // Stop watching the table while we write to it, so our own edits never re-trigger us.
    observer.disconnect();

    var converted = false;
    document.querySelectorAll('.hulkapps-price').forEach(function(span) {
      var pct;
      if (span.hasAttribute('data-hulk-pct')) {
        pct = parseFloat(span.getAttribute('data-hulk-pct'));
      } else {
        var text = span.textContent.trim();
        var pctMatch = text.match(/^(\d+(?:\.\d+)?)%/);
        if (pctMatch) {
          pct = parseFloat(pctMatch[1]);
          span.setAttribute('data-hulk-pct', pct);
        }
      }

      if (pct !== undefined && !isNaN(pct)) {
        setText(span, '$' + (basePrice * (1 - pct / 100)).toFixed(2));
        converted = true;
      }
    });

    if (converted) {
      document.querySelectorAll('.hulkapps-table th').forEach(function(th) {
        if (th.textContent.indexOf('Percent Saved') !== -1) {
          setText(th, 'Est. Price:');
        }
      });
    }

    observer.takeRecords();
    if (observedTable) {
      observer.observe(observedTable, { childList: true, subtree: true, characterData: true });
    }
  }

  setTimeout(updateVolumeTable, 500);
  setTimeout(updateVolumeTable, 1500);
  setTimeout(updateVolumeTable, 3000);

  function hookHulkapps() {
    if (window.hulkapps_jQuery) {
      hulkapps_jQuery(document).ajaxComplete(function() {
        setTimeout(updateVolumeTable, 100);
        setTimeout(updateVolumeTable, 500);
      });
    }
  }
  hookHulkapps();
  setTimeout(hookHulkapps, 1000);

  // Watch Hulk table for mutations (percentages reappearing on variant change)
  var observer = new MutationObserver(function() {
    setTimeout(updateVolumeTable, 50);
  });
  var observedTable = null;
  function startObserver() {
    var hulkTable = document.querySelector('.hulkapps-table');
    if (hulkTable) {
      observedTable = hulkTable;
      observer.observe(hulkTable, { childList: true, subtree: true, characterData: true });
    }
  }
  setTimeout(startObserver, 1000);
  setTimeout(startObserver, 3000);

  // Watch the GemPages price element for changes (variant switch)
  var priceObserver = new MutationObserver(function() {
    setTimeout(updateVolumeTable, 100);
  });
  function startPriceObserver() {
    var targets = document.querySelectorAll('.gf_product-price, .gf_product-prices, .sls-price-container, .price-list');
    targets.forEach(function(el) {
      priceObserver.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }
  setTimeout(startPriceObserver, 500);
  setTimeout(startPriceObserver, 2000);

  // Listen for swatch/variant selector changes
  document.addEventListener('change', function(e) {
    if (e.target.matches('.product-form__single-selector, .gf_product-variants input, .gf_product-variants select, [name*="option"]')) {
      setTimeout(updateVolumeTable, 200);
      setTimeout(updateVolumeTable, 600);
    }
  });

  // Also catch click events on color swatches (some don't fire change)
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.color-swatch, .color-swatch__item, .gf_product-color, [data-option-position]');
    if (swatch) {
      setTimeout(updateVolumeTable, 200);
      setTimeout(updateVolumeTable, 600);
      setTimeout(updateVolumeTable, 1000);
    }
  });

  var lastUrl = location.href;
  setInterval(function() {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(updateVolumeTable, 300);
    }
  }, 200);
})();
